import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import instance from "../../../store/actions/instance";

// Antd Components
import { Button, Modal, Spin, message } from "antd";

// Actions
import PaymentsSummary from "./PaymentsSummary";
import CashMovements from "./CashMovements";
import { LoadingOutlined } from "@ant-design/icons";
import RegisterOpening from "../POSCart/RegisterOpening";
import RegistersList from "./RegistersList";
import { updateSelectedRegisterPOS } from "../../../store/actions/pos";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

class RegistersModal extends Component {
  state = {
    loading: false,
    payments: null,
    cashMovements: null,

    closingLoading: false,
  };
  getRegisterSummary = async () => {
    const { t, selectedRegister } = this.props;
    try {
      if (!selectedRegister || !selectedRegister.is_open) return;
      this.setState({ loading: true });
      const res = await instance.post(`get_register_summary/`, {
        registerId: selectedRegister.id,
      });

      this.setState({
        loading: false,
        payments: res.data.payments,
        cashMovements: res.data.cash_movements,
        closingId: res.data.closing_id,
      });
    } catch (err) {
      if (err.response && err.response.status == 403)
        message.error(t("AccessDeniedMessage"));
      else message.error(t("SomethingWentWrong"));
    }
  };
  componentDidMount = async () => {
    this.getRegisterSummary();
  };

  render() {
    const { visible, t, config, settings, selectedRegister } = this.props;

    const { loading, payments, closingLoading, cashMovements } = this.state;
    const currency =
      config.language == "arabic" ? settings.currency_local : settings.currency;
    return (
      <Modal
        style={{ top: 20 }}
        destroyOnClose={true}
        title={
          <div
            className="ant-modal-title"
            style={{
              textAlign: config.direction == "rtl" ? "right" : "left",
            }}
          >
            {t("Registers")}
          </div>
        }
        footer={null}
        visible={visible}
        onCancel={() => !closingLoading && this.props.onClose()}
        okText={t("Save")}
        cancelText={t("Close")}
        width={1000}
        bodyStyle={{
          paddingTop: 0,
          width: "auto",
          padding: "0px 18px",
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 300 }}
          >
            <Spin indicator={antIcon} />
          </div>
        ) : (
          <div className="px-2 my-3 d-flex flex-column" style={{ gap: 20 }}>
            {!selectedRegister ? (
              <RegistersList closeModal={this.props.onClose} />
            ) : !selectedRegister?.is_open ? (
              <div>
                <Button
                  onClick={() => {
                    this.props.updateSelectedRegisterPOS(null);
                  }}
                  type="priamry"
                >
                  {t("Switch Register")}
                </Button>
                <RegisterOpening closeModal={this.props.onClose} />
              </div>
            ) : (
              <>
                <CashMovements
                  cashMovements={cashMovements}
                  getRegisterSummary={this.getRegisterSummary}
                />
                <PaymentsSummary
                  currency={currency}
                  loading={loading}
                  payments={payments}
                  setClosingLoading={(v) =>
                    this.setState({ closingLoading: v })
                  }
                  closingLoading={closingLoading}
                  closeModal={this.props.onClose}
                />
              </>
            )}
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    selectedRegister: state.pos.selectedRegister,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateSelectedRegisterPOS: (payload) =>
      dispatch(updateSelectedRegisterPOS(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(RegistersModal));
